import { Col, Form, Select } from "antd";
import { getData } from "apiServices/common";
import { useEffect, useState } from "react";

const CertificateOfOriginFeeFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState({
    salesContracts: false,
    invoices: false,
  });

  // Get invoice numbers for filter
  const getInvoiceNumbers = async () => {
    setLoading((prev) => ({ ...prev, invoices: true }));
    const response = await getData(`/api/accounting/export_invoice_numbers`);
    if (response?.status === 200) {
      setInvoices(response?.data?.data || []);
    }
    setLoading((prev) => ({ ...prev, invoices: false }));
  };

  useEffect(() => {
    getInvoiceNumbers();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Invoice Number" name="invoice_id">
          <Select
            size="small"
            placeholder="Select Invoice Number"
            loading={loading.invoices}
            showSearch
            optionFilterProp="children"
            allowClear
          >
            {invoices.map((invoice) => (
              <Option key={invoice.id} value={invoice.id}>
                {invoice.invoice_number}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default CertificateOfOriginFeeFilterFields;
